import React from 'react'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { Inline } from '@/components/shared/atoms/layout/Inline'
import { CardShell } from '@/components/frontend/atoms/content/CardShell'
import { CardBody } from '@/components/frontend/atoms/content/CardBody'
import { Avatar } from '@/components/frontend/atoms/media/Avatar'
import { Heading } from '@/components/frontend/atoms/typography/Heading'
import { Text } from '@/components/frontend/atoms/typography/Text'
import { ButtonLink } from '@/components/frontend/atoms/navigation/ButtonLink'
import { useTranslation } from '@/hooks/useTranslation'

const AUTHOR_NAME = 'Mario'

export const AuthorCTA: React.FC = () => {
  const { t, lp } = useTranslation()

  return (
    <CardShell variant="featured">
      <CardBody padding="lg">
        <Inline gap="6" align="start" wrap>
          <Avatar alt={AUTHOR_NAME} size="md" />
          <Stack gap="4" align="start">
            <Stack gap="2">
              <Heading level="3" as="h2">{t('blog.author_title')}</Heading>
              <Text tone="muted">{t('blog.author_text')}</Text>
            </Stack>
            <ButtonLink href={lp('/#contatti')} arrow>{t('blog.author_cta')}</ButtonLink>
          </Stack>
        </Inline>
      </CardBody>
    </CardShell>
  )
}
